@if (errorMessage?.message?.length > 0) {
  <div class="margin-bottom">
    <nfrp-alert alertId="plan-trustee-error" [message]="errorMessage" type="error" [page]="false"> </nfrp-alert>
  </div>
}
<ul
  id="trustee-params"
  summary="trustee"
  class="ul-li-view-edit table stripes no-margin"
  style="border: 1px solid #9c9c9c"
  >
  <li class="head" [ngClass]="{'pending-status-bg':pendingStatus}">
    <div class="col-sm-12 padding-left">
      <b>Trustee</b>
    </div>
  </li>
  <li>
    @if (trusteeObj) {
      <div class="col-sm-6 padding-left">
        <span id="trustee-value">
          {{ trusteeObj?.trusteeLastName | nfrpNormalizeValue : '' }},
          {{ trusteeObj?.trusteeFirstName | nfrpNormalizeValue : '' }}
        </span>
      </div>
    }
  </li>
  <!-- *ngIf="showEditCorePlanOption||showArchiveOption" -->
  @if (!archivePlanStatus && !isMoneyMgrUser) {
    <li>
      <div class="col-sm-12 padding-left">
        <b>
          @if (trusteeObj && status) {
            <a href="javascript:void(0);" class="subLink" routerLink="trustee/edit">Edit </a
              >
              }@if (trusteeObj && status) {
              <span>&nbsp; - &nbsp;</span>
            }
            @if (trusteeObj && status) {
              <a href="javascript:void(0);" class="subLink" routerLink="trustee/remove">
                Remove
              </a>
            }
            @if (!trusteeObj && status) {
              <a href="javascript:void(0);" class="subLink" routerLink="trustee/add"> Add Trustee</a>
              }</b
              >
            </div>
          </li>
        }
      </ul>
